import { render, staticRenderFns } from "./user_dialog.vue?vue&type=template&id=3a8f1d0b&scoped=true&"
import script from "./user_dialog.vue?vue&type=script&lang=js&"
export * from "./user_dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8f1d0b",
  null
  
)

export default component.exports